import { render, staticRenderFns } from "./FormDateItem.vue?vue&type=template&id=15593275&scoped=true"
import script from "./FormDateItem.vue?vue&type=script&lang=js"
export * from "./FormDateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15593275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15593275')) {
      api.createRecord('15593275', component.options)
    } else {
      api.reload('15593275', component.options)
    }
    module.hot.accept("./FormDateItem.vue?vue&type=template&id=15593275&scoped=true", function () {
      api.rerender('15593275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormDateItem.vue"
export default component.exports